import { openEditorModal } from './editorModal';
import { configDeviceList } from '../config/devicesList';


export const STACK_DEVICE_OPTIONS = [
    { value: 'none', label: 'Nie (immer nebeneinander)' },
    ...configDeviceList.devices
        .filter((device) => device.id !== configDeviceList.default)
        .map((device) => ({ value: device.id, label: device.name })),
];

const STACK_DEVICE_IDS = STACK_DEVICE_OPTIONS.map((opt) => opt.value);

export const DEFAULT_LAYOUT_CONFIG = {
    columns: [1, 1],
    gap: 16,
    stackBelow: 'md',
    valign: 'stretch',
    halign: 'start',
};

export const MAX_COLUMNS = 12;

// Common ratio presets grouped by column count.
const PRESETS = {
    1: [{ label: '1', columns: [1] }],
    2: [
        { label: '1 : 1', columns: [1, 1] },
        { label: '1 : 2', columns: [1, 2] },
        { label: '2 : 1', columns: [2, 1] },
        { label: '1 : 3', columns: [1, 3] },
        { label: '3 : 1', columns: [3, 1] },
    ],
    3: [
        { label: '1 : 1 : 1', columns: [1, 1, 1] },
        { label: '1 : 2 : 1', columns: [1, 2, 1] },
        { label: '2 : 1 : 1', columns: [2, 1, 1] },
        { label: '1 : 1 : 2', columns: [1, 1, 2] },
    ],
    4: [{ label: '1 : 1 : 1 : 1', columns: [1, 1, 1, 1] }],
    5: [{ label: 'Gleich', columns: [1, 1, 1, 1, 1] }],
    6: [{ label: 'Gleich', columns: [1, 1, 1, 1, 1, 1] }],
    7: [{ label: 'Gleich', columns: [1, 1, 1, 1, 1, 1, 1] }],
    8: [{ label: 'Gleich', columns: [1, 1, 1, 1, 1, 1, 1, 1] }],
    9: [{ label: 'Gleich', columns: [1, 1, 1, 1, 1, 1, 1, 1, 1] }],
    10: [{ label: 'Gleich', columns: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1] }],
    11: [{ label: 'Gleich', columns: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1] }],
    12: [{ label: 'Gleich', columns: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1] }],
};

export const normalizeLayoutConfig = (raw) => {
    const cfg = { ...DEFAULT_LAYOUT_CONFIG, ...(raw || {}) };

    let columns = Array.isArray(cfg.columns) ? cfg.columns : [];
    columns = columns
        .map((n) => Math.max(1, Math.round(Number(n) || 1)))
        .slice(0, MAX_COLUMNS);
    if (!columns.length) columns = [...DEFAULT_LAYOUT_CONFIG.columns];

    return {
        columns,
        gap: Math.max(0, Number(cfg.gap) || 0),
        stackBelow: STACK_DEVICE_IDS.includes(cfg.stackBelow)
            ? cfg.stackBelow
            : 'md',
        valign: ['start', 'center', 'end', 'stretch'].includes(cfg.valign)
            ? cfg.valign
            : 'stretch',
        halign: ['start', 'center', 'end', 'between', 'around', 'evenly'].includes(
            cfg.halign
        )
            ? cfg.halign
            : 'start',
    };
};

const el = (tag, cssText, text) => {
    const node = document.createElement(tag);
    if (cssText) node.style.cssText = cssText;
    if (text != null) node.textContent = text;
    return node;
};

const LABEL_CSS =
    'display:block;font-size:12px;font-weight:600;color:#3f3f46;margin:0 0 6px;';
const FIELD_WRAP_CSS = 'margin:0 0 18px;';
const INPUT_CSS =
    'width:100%;box-sizing:border-box;border:1px solid #d4d4d8;border-radius:8px;' +
    'padding:8px 10px;font-size:13px;color:#18181b;background:#fff;outline:none;';
const SELECT_CSS = INPUT_CSS + 'cursor:pointer;';


export const openDynamicLayoutModal = (initialConfig) => {
    const state = normalizeLayoutConfig(initialConfig);

    const container = el('div', 'display:flex;flex-direction:column;');

    const previewLabel = el('label', LABEL_CSS, 'Vorschau');
    const preview = el(
        'div',
        'display:flex;gap:6px;height:56px;background:#f4f4f5;border:1px solid #e4e4e7;' +
            'border-radius:8px;padding:6px;margin:0 0 18px;'
    );

    const countWrap = el('div', FIELD_WRAP_CSS);
    countWrap.appendChild(el('label', LABEL_CSS, 'Anzahl der Spalten'));
    const countRow = el('div', 'display:flex;gap:6px;flex-wrap:wrap;');
    countWrap.appendChild(countRow);

    const presetWrap = el('div', FIELD_WRAP_CSS);
    presetWrap.appendChild(el('label', LABEL_CSS, 'Vorlagen'));
    const presetRow = el('div', 'display:flex;gap:6px;flex-wrap:wrap;');
    presetWrap.appendChild(presetRow);

    const ratioWrap = el('div', FIELD_WRAP_CSS);
    ratioWrap.appendChild(
        el('label', LABEL_CSS, 'Spaltenverhältnis (Gewichtung)')
    );
    const ratioRow = el('div', 'display:flex;gap:6px;flex-wrap:wrap;');
    ratioWrap.appendChild(ratioRow);

    const gapWrap = el('div', FIELD_WRAP_CSS);
    gapWrap.appendChild(el('label', LABEL_CSS, 'Abstand zwischen Spalten (px)'));
    const gapInput = el('input', INPUT_CSS);
    gapInput.type = 'number';
    gapInput.min = '0';
    gapInput.value = String(state.gap);
    gapInput.addEventListener('input', () => {
        state.gap = Math.max(0, Number(gapInput.value) || 0);
        renderPreview();
    });
    gapWrap.appendChild(gapInput);

    const stackWrap = el('div', FIELD_WRAP_CSS);
    stackWrap.appendChild(el('label', LABEL_CSS, 'Stapeln unter'));
    const stackSelect = el('select', SELECT_CSS);
    STACK_DEVICE_OPTIONS.forEach((opt) => {
        const o = el('option', '', opt.label);
        o.value = opt.value;
        if (opt.value === state.stackBelow) o.selected = true;
        stackSelect.appendChild(o);
    });
    stackSelect.addEventListener('change', () => {
        state.stackBelow = stackSelect.value;
    });
    stackWrap.appendChild(stackSelect);

    const alignGrid = el(
        'div',
        'display:grid;grid-template-columns:1fr 1fr;gap:12px;' + FIELD_WRAP_CSS
    );

    const valignWrap = el('div');
    valignWrap.appendChild(el('label', LABEL_CSS, 'Vertikale Ausrichtung'));
    const valignSelect = el('select', SELECT_CSS);
    [
        { value: 'stretch', label: 'Dehnen' },
        { value: 'start', label: 'Oben' },
        { value: 'center', label: 'Mitte' },
        { value: 'end', label: 'Unten' },
    ].forEach((opt) => {
        const o = el('option', '', opt.label);
        o.value = opt.value;
        if (opt.value === state.valign) o.selected = true;
        valignSelect.appendChild(o);
    });
    valignSelect.addEventListener('change', () => {
        state.valign = valignSelect.value;
    });
    valignWrap.appendChild(valignSelect);

    const halignWrap = el('div');
    halignWrap.appendChild(el('label', LABEL_CSS, 'Horizontale Verteilung'));
    const halignSelect = el('select', SELECT_CSS);
    [
        { value: 'start', label: 'Start' },
        { value: 'center', label: 'Mitte' },
        { value: 'end', label: 'Ende' },
        { value: 'between', label: 'Zwischenraum' },
        { value: 'around', label: 'Umgebend' },
        { value: 'evenly', label: 'Gleichmäßig' },
    ].forEach((opt) => {
        const o = el('option', '', opt.label);
        o.value = opt.value;
        if (opt.value === state.halign) o.selected = true;
        halignSelect.appendChild(o);
    });
    halignSelect.addEventListener('change', () => {
        state.halign = halignSelect.value;
    });
    halignWrap.appendChild(halignSelect);

    alignGrid.append(valignWrap, halignWrap);

    const renderPreview = () => {
        preview.innerHTML = '';
        const total = state.columns.reduce((a, b) => a + b, 0) || 1;
        state.columns.forEach((w) => {
            const col = el(
                'div',
                'background:#0991b2;border-radius:4px;min-width:8px;' +
                    `flex:${w} 1 0;`
            );
            col.style.margin = `0 ${state.gap / 6}px`;
            preview.appendChild(col);
        });
        void total;
    };

    const renderRatios = () => {
        ratioRow.innerHTML = '';
        state.columns.forEach((w, index) => {
            const input = el(
                'input',
                'width:56px;box-sizing:border-box;border:1px solid #d4d4d8;' +
                    'border-radius:8px;padding:8px 6px;font-size:13px;text-align:center;' +
                    'color:#18181b;background:#fff;outline:none;'
            );
            input.type = 'number';
            input.min = '1';
            input.max = '12';
            input.value = String(w);
            input.title = `Spalte ${index + 1}`;
            input.addEventListener('input', () => {
                state.columns[index] = Math.max(
                    1,
                    Math.min(12, Math.round(Number(input.value) || 1))
                );
                renderPreview();
            });
            ratioRow.appendChild(input);
        });
    };

    const renderPresets = () => {
        presetRow.innerHTML = '';
        (PRESETS[state.columns.length] || []).forEach((preset) => {
            const btn = el(
                'button',
                'border:1px solid #d4d4d8;background:#fff;border-radius:8px;' +
                    'padding:6px 12px;font-size:12px;cursor:pointer;color:#3f3f46;',
                preset.label
            );
            btn.type = 'button';
            btn.addEventListener('click', () => {
                state.columns = [...preset.columns];
                renderRatios();
                renderPreview();
            });
            presetRow.appendChild(btn);
        });
    };

    const setColumnCount = (count) => {
        const next = [...state.columns];
        if (count > next.length) {
            while (next.length < count) next.push(1);
        } else {
            next.length = count;
        }
        state.columns = next;
        renderCountButtons();
        renderPresets();
        renderRatios();
        renderPreview();
    };

    const renderCountButtons = () => {
        countRow.innerHTML = '';
        for (let n = 1; n <= MAX_COLUMNS; n += 1) {
            const active = state.columns.length === n;
            const btn = el(
                'button',
                'width:38px;height:38px;border-radius:8px;font-size:14px;cursor:pointer;' +
                    'border:1px solid ' +
                    (active ? '#0991b2' : '#d4d4d8') +
                    ';background:' +
                    (active ? '#0991b2' : '#fff') +
                    ';color:' +
                    (active ? '#fff' : '#3f3f46') +
                    ';',
                String(n)
            );
            btn.type = 'button';
            btn.addEventListener('click', () => setColumnCount(n));
            countRow.appendChild(btn);
        }
    };

    container.append(
        previewLabel,
        preview,
        countWrap,
        presetWrap,
        ratioWrap,
        gapWrap,
        stackWrap,
        alignGrid
    );

    renderCountButtons();
    renderPresets();
    renderRatios();
    renderPreview();

    return openEditorModal({
        title: 'Layout bearbeiten',
        content: container,
        width: 580,
        confirmText: 'Übernehmen',
        cancelText: 'Abbrechen',
    }).then((result) =>
        result?.confirmed ? normalizeLayoutConfig(state) : null
    );
};

export default openDynamicLayoutModal;
